export default function initRangeSlider() {
  const sliders = document.querySelectorAll(".range-slider");

  if (!sliders.length) return;

  sliders.forEach((slider) => {
    const minInput = slider.querySelector(".range-slider-min");
    const maxInput = slider.querySelector(".range-slider-max");
    const fill = slider.querySelector(".range-slider-fill");
    const labelMin = slider.querySelector(".range-slider-label-min");
    const labelMax = slider.querySelector(".range-slider-label-max");

    if (!minInput || !maxInput || !fill) return;

    const min = parseFloat(minInput.min);
    const max = parseFloat(minInput.max);

    function update() {
      let minVal = parseFloat(minInput.value);
      let maxVal = parseFloat(maxInput.value);

      // Prevent crossing
      if (minVal > maxVal) {
        minInput.value = maxVal;
        minVal = maxVal;
      }
      if (maxVal < minVal) {
        maxInput.value = minVal;
        maxVal = minVal;
      }

      const range = max - min;
      const leftPercent = ((minVal - min) / range) * 100;
      const rightPercent = ((maxVal - min) / range) * 100;

      fill.style.left = `${leftPercent}%`;
      fill.style.width = `${rightPercent - leftPercent}%`;

      if (labelMin) {
        labelMin.textContent = minVal;
        labelMin.style.right = `${100 - leftPercent}%`;
      }
      if (labelMax) {
        labelMax.textContent = maxVal;
        labelMax.style.left = `${rightPercent}%`;
      }
    }

    minInput.addEventListener("input", update);
    maxInput.addEventListener("input", update);

    update();
  });
}
